module.exports = __webpack_public_path__ + "img/fans.4b2eda1d.jpg";